const funcoes = [
    { funcao: "LIQUIDANTE", csFuncao: "1" },
    { funcao: "ADMINISTRADOR ESPECIAL", csFuncao: "2" },
    { funcao: "INTERVENTOR", csFuncao: "3" }
];

export function obterFuncoesDirigenteExcepcional(){
    return funcoes;
}
export function obterFuncaoPorNumero(csFuncao:number){
    const tmp = funcoes[csFuncao-1];
    return {valor: tmp.csFuncao, descricao: tmp.funcao};
}

export function obterFuncaoPorTipoObjeto(csObjeto:number){
    if (csObjeto === 1) {
        return [funcoes[0], funcoes[2]];
    } else if (csObjeto === 2) {
        return [funcoes[0], funcoes[1]];
    } else {
        return [];
    }
}

const objetos = [
    { objeto: "ENTIDADE", csObjeto: 1 },
    { objeto: "PLANO BENEFÍCIOS", csObjeto: 2 }
]

export function obterObjetosDirigenteExcepcional(){
    return objetos;
}
export function obterObjetoDirExcepPorNumero(csObjeto:number){
    const tmp = objetos[csObjeto-1];
    return {valor: tmp.csObjeto, descricao: tmp.objeto};
}
